import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { TextField } from 'material-ui';


import Months from '../../../../utils/Months';
import './MonthlykWhInputs.css';

class MonthlykWhInputs extends Component {
    handleMonthlyKWHChange(value, month) {
        const { setMonthlyKWHInputs } = this.props;
        setMonthlyKWHInputs(Number(value), month);
    }

    render() {
        const { monthlyKWh, isLocked } = this.props;
        return (
            <div>
                {Months.map(month => (
                    <div className="TextFields" key={month}>
                        <TextField
                            onChange={(e, value) => {
                                this.handleMonthlyKWHChange(value, month);
                            }}
                            disabled={isLocked}
                            defaultValue={monthlyKWh[month]}
                            floatingLabelText={month}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

MonthlykWhInputs.propTypes = {
    isLocked: PropTypes.bool.isRequired,
    monthlyKWh: PropTypes.object.isRequired,
    setMonthlyKWHInputs: PropTypes.func.isRequired,
};

export default MonthlykWhInputs;



// WEBPACK FOOTER //
// ./src/containers/Inputs/UtilityInputs/MonthlykWhInputs/MonthlykWhInputs.js